// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore, getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

/**
 * Safari / iOS WebKit can hang indefinitely on Firestore streaming fetch.
 * Disable fetch streams there so the SDK uses XHR instead.
 * @see https://github.com/firebase/firebase-js-sdk/issues/9789
 */
function shouldUseFetchStreams() {
  if (typeof navigator === "undefined") return true;

  const ua = navigator.userAgent;
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isMacSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);

  return !(isIOS || isMacSafari);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let db;
try {
  db = initializeFirestore(app, {
    useFetchStreams: shouldUseFetchStreams(),
  });
} catch {
  // Hot reload / already initialized
  db = getFirestore(app);
}

const auth = getAuth(app);
const storage = getStorage(app);

export { auth, db, storage };
